import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M18 2.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm-2.764 4.706a3.6 3.6 0 1 0-.605-1.036L8.763 9.694a3.6 3.6 0 1 0 0 4.612l5.868 3.42a3.6 3.6 0 1 0 .607-1.035l-5.87-3.421c.15-.395.23-.823.23-1.27 0-.447-.08-.875-.23-1.27l5.867-3.424ZM8.049 10.75a.6.6 0 0 0 .049.083c.192.345.302.743.302 1.167a2.389 2.389 0 0 1-.35 1.25 2.4 2.4 0 1 1 0-2.5Zm7.829 7.128a.607.607 0 0 0 .104-.178 2.4 2.4 0 1 1-.104.178Z"
      clip-rule="evenodd"
    />
  </svg>
`;
